import React from "react";
import orgData from "../../data/organization.json";
import staffData from "../../data/staffList.json";
import styles from "../../styles/profile/Organization.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Organization() {
  return (
    <div className={cx("orgWrap")}>
      <div className={cx("title")}>
        <h4>조직도 및 전문인력</h4>
      </div>
      <div className={cx("orgTreeContainer", "reveal")}>
        <div className={cx("orgTree")}>
          {/* 조직도의 뼈대가 되는 ul/li에는 treeLayer와 treeItem 클래스 부여 */}
          <ul className={cx("treeLayer")}>
            <li className={cx("treeItem")}>
              {/* 최상단: 대표이사 노드 */}
              <div className={cx("node", "ceoNode", "liftUp")}>
                {orgData.ceo}
              </div>

              {/* 하위 노드들: 팀 카드 목록 */}
              <ul className={cx("treeLayer")}>
                {orgData.teams.map((team, index) => (
                  <li key={index} className={cx("treeItem")}>
                    <div className={cx("node", "teamNode", "liftUp")}>
                      {/* 팀 헤더: 팀명 및 설명 */}
                      <div className={cx("teamHeader")}>
                        <span className={cx("teamName")}>{team.name}</span>
                        {team.type === "list" && (
                          <span className={cx("teamDesc")}>{team.desc}</span>
                        )}
                      </div>

                      {/* 팀 바디: 상세 리스트 */}
                      <div className={cx("teamBody")}>
                        {/* type이 'list'인 경우 items 배열 렌더링 */}
                        {team.type === "list" && (
                          <ul className={cx("innerList")}>
                            {team.items.map((item, idx) => (
                              <li key={idx} className={cx("innerItem")}>
                                {item}
                              </li>
                            ))}
                          </ul>
                        )}

                        {/* type이 'descList'인 경우 desc 배열 렌더링 */}
                        {team.type === "descList" && (
                          <ul className={cx("innerList")}>
                            {team.desc.map((item, idx) => (
                              <li key={idx} className={cx("innerItem")}>
                                {item}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <CardGrid />
    </div>
  );
}

/* 팀 */
const Team = ({ team }) => {
  return (
    <div className={cx("team")}>
      <div className={cx("node", "nodeBox")}>{team.name}</div>
      <div className={cx("vLine")} />

      {team.type === "list" && (
        <>
          <div className={cx("node", "descBox")}>{team.desc}</div>
          <div className={cx("vLine")} />

          <div className={cx("items")}>
            {team.items.map((item, i) => (
              <div key={i} className={cx("node", "itemBox")}>
                {item}
              </div>
            ))}
          </div>
        </>
      )}

      {team.type === "descList" && (
        <div className={cx("items")}>
          {team.desc.map((d, i) => (
            <div key={i} className={cx("node", "descListBox")}>
              {d}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const CardGrid = () => {
  return (
    <div className={cx("cardGrid")}>
      {staffData.staffList.map((item, index) => (
        <div className={cx("staffCard", "reveal")} key={index}>
          <p className={cx("name")}>{item.name}</p>
          <h2>{item.position}</h2>

          <div className={cx("section")}>
            <strong>자격</strong>
            <ul className={cx("sectionUl")}>
              {item.qualifications.map((q, i) => (
                <li className={cx("sectionLi")} key={i}>
                  {q}
                </li>
              ))}
            </ul>
          </div>

          <div className={cx("section")}>
            <strong>경력</strong>
            <ul className={cx("sectionUl")}>
              {item.career.length > 0 ? (
                item.career.map((c, i) => (
                  <li className={cx("sectionLi")} key={i}>
                    {c}
                  </li>
                ))
              ) : (
                <li className={cx("sectionLi")}>-</li>
              )}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};
